import { Alert, Button, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface LoadErrorProps {
    error?: Error | null;
    onRetry?: () => void;
}

const LoadError = ({ error, onRetry }: LoadErrorProps) => {
    const { t } = useTranslation('budget');
    return (
        <Box sx={{ p: 2 }}>
            <Alert
                severity="error"
                action={
                    onRetry ? (
                        <Button color="inherit" size="small" onClick={onRetry}>
                            <span>{t('action.retry')}</span>
                        </Button>
                    ) : undefined
                }
            >
                {error?.message || t('hint.loadFailed')}
            </Alert>
        </Box>
    );
};

export default LoadError;
